module.exports = __webpack_public_path__ + "static/why-us-3-e61b7c5081aac9a1fcea6090c9056fc6.jpg";